import { tget, tpost } from '../../utils/Utils/Utils';

export function actionFetchRoutines() {
  return (dispatch) =>
    tget('/api/v3/torga/routine').then((result) => {
      dispatch({ type: 'ROUTINE_FETCH_COMPLETE', payload: result });
    });
}

export function actionAddRoutine(routineName) {
  return (dispatch) => {
    tpost('/api/v3/torga/routine', { name: routineName }).then((result) => {
      dispatch({ type: 'ROUTINE_ADD_COMPLETE', payload: [result] });
    });
  };
}

export function actionPersistRoutine(id, field, value) {
  return (dispatch) =>
    tpost(`/api/v3/torga/routine/${id}`, { [field]: value }).then((result) => {
      dispatch({ type: 'ROUTINE_PERSIST_COMPLETE', payload: [result] });
    });
}

export function actionDeleteRoutine(id) {
  return actionPersistRoutine(id, 'deleted', true);
}

export function actionRoutineFetchActivities() {
  return (dispatch) =>
    tget('/api/v3/torga/routineactivities').then((result) => {
      dispatch({ type: 'ROUTINEACTIVITIES_FETCH_COMPLETE', payload: result });
    });
}

export function actionRoutineAddActivity(routine_id, activity_id) {
  return (dispatch) => {
    tpost(`/api/v3/torga/routineactivities`, {
      routine_id,
      activity_id,
      deleted: false,
    }).then((result) => {
      dispatch({
        type: 'ROUTINEACTIVITIES_ADD',
        payload: [result],
      });
    });
  };
}

export function actionRoutineRemoveActivity(routine_id, activity_id) {
  return (dispatch) => {
    tpost(`/api/v3/torga/routineactivities`, {
      routine_id,
      activity_id,
      deleted: true,
    }).then((result) => {
      dispatch({
        type: 'ROUTINEACTIVITIES_REMOVE',
        payload: [result],
      });
    });
  };
}
